import { render, staticRenderFns } from "./CustomBlacklisted.vue?vue&type=template&id=45628478&"
import script from "./CustomBlacklisted.vue?vue&type=script&lang=js&"
export * from "./CustomBlacklisted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports